/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { VIEW_LOOK, GA4_EVENT_VIEW_LOOK, PAGE_DATA_LAYER } from '@/data/constants/gtm';
import { getGTMViewLookEventData } from '@/data/events/data/gtm/ViewLook';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { GTMViewLookPayload } from '@/data/types/GTM';
import { error as logError } from '@/data/utils/loggerUtil';
import TagManager from 'react-gtm-module';

export const measure_GA4 = async (data: Awaited<ReturnType<typeof getGTMViewLookEventData>>) => {
	const dataLayerName = PAGE_DATA_LAYER;

	TagManager.dataLayer({
		dataLayer: { event: GA4_EVENT_VIEW_LOOK, ecommerce: null },
		dataLayerName,
	}); // Clean up previous ecommerce object

	const tagManagerArgs = {
		dataLayer: {
			event: GA4_EVENT_VIEW_LOOK,
			...data,
		},
		dataLayerName,
	};
	TagManager.dataLayer(tagManagerArgs);
};

export const measure_UA = async (data: Awaited<ReturnType<typeof getGTMViewLookEventData>>) => {
	const dataLayerName = PAGE_DATA_LAYER;

	TagManager.dataLayer({ dataLayer: { event: VIEW_LOOK, ecommerce: null }, dataLayerName }); // Clean up previous ecommerce object

	const tagManagerArgs = {
		dataLayer: {
			event: VIEW_LOOK,
			...data,
		},
		dataLayerName,
	};
	TagManager.dataLayer(tagManagerArgs);
};

export const sendGTMViewLookEvent = async (payload: GTMViewLookPayload) => {
	const { ga4, ua } = getGTMConfig(payload.settings);

	if (ua || ga4) {
		const data = await getGTMViewLookEventData(payload);
		if (ua) {
			try {
				await measure_UA(data);
			} catch (error) {
				logError(undefined, 'ViewLook: sendGTMViewLookEvent: measure_UA: error: %o', error);
			}
		}

		if (ga4) {
			try {
				await measure_GA4(data);
			} catch (error) {
				logError(undefined, 'ViewLook: sendGTMViewLookEvent: measure_GA4: error: %o', error);
			}
		}
	}
};
